import { Turnstile } from "@marsidev/react-turnstile"

export default function Captcha(props) {

    const TURNSTILE_SITE_KEY = process.env.TURNSTILE_SITE_KEY

    return (
        <Turnstile
            className='mb-10'
            siteKey={TURNSTILE_SITE_KEY}
            onSuccess={() => {props.setCaptcha(true)}}
            options={{theme: 'light'}}
        />
    )
}